import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { map, catchError, retry, retryWhen, scan, delay, timeout } from 'rxjs/operators';
import { IProduct } from './product';
import { IRep } from '../home/rep';
import { LoginService } from '../home/login.service';
import { IProductDetail } from './productdetails';
import { IRepPublicData } from '../home/repPublicData';
import { ApiCacheService } from '../core/api-cache.service';


@Injectable()
export class ProductService {
    private _productUrl = 'https://webapi.securefreedom.com/Lbri/api/inventory/InventoryShopping?customerDID=800003' + '&categoryID=67&langKey=' + this.getLocale() + '-us';
    //this.login.userId.replace('-->c_', '') +
    private _repInfoCall = 'https://webapi.bydesign.com/Lbri/api/rep/PublicInfo?repDID=';
    private prodDetailsUrl = 'https://webapi.securefreedom.com/Lbri/api/inventory/InventoryShopping?productID=';
    private prodUrl2 = 'https://webapi.bydesign.com/Lbri/api/inventory/collection/19/ForBackOfficeOrder?customerDID=800003&langKey=' + this.getLangKeyTest() + '&country=US';
    private prodUrl3 = 'https://samplecart.lbri.net/api/api/Products/BDT/GetFSSProducts/113';
    
    private prodDetailsUrl2 = 'https://samplecart.lbri.net/api/api/GetProductDetails3/';

    public rfirstName: string = "";
    public rlastName: string = "";
    public repDID: string = "";
    public langKey: string = "";
    constructor(
        private _http: HttpClient,
        private login: LoginService,
        private cache: ApiCacheService
    ) {

    }

    getLocale(): any {
        var currentLocale = localStorage.getItem('locale');
        return currentLocale;
    }
    getLangKey(): any {
        let lc = this.getLocale();
        //console.log('here is the locale: ' + lc);

        if (lc === 'en')
            this.langKey = '1';
        else
            this.langKey = '134'
        return this.langKey
    }
    getLangKeyTest(): any {
        let lc = this.getLocale();
        //console.log('here is the locale: ' + lc);

        if (lc === 'en')
            this.langKey = 'en-us';
        else
            this.langKey = 'es-us'
        return this.langKey
    }
    getProducts(): Observable<IProduct[]> {
        const key = `products:v1:${this.getLocale()}`;
        return this.cache.get<IProduct[]>(
            key,
            () => this._http.get<IProduct[]>(this._productUrl).pipe(
                retryWhen(e => e.pipe(scan((errorCount, error) => {
                    if (errorCount >= 3) {
                        throw error;
                    }
                    return errorCount + 1;
                }, 0), delay(3000))),
                catchError(this.handleError)
            ),
            5 * 60_000
        );
    }

    getProducts2(): Observable<IProduct[]> {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
        
        const key = `products:v2:${this.getLangKey()}`;
        return this.cache.get<IProduct[]>(
            key,
            () => this._http.get<IProduct[]>(this.prodUrl3).pipe(
                retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),
                catchError(this.handleError)
            ),
            5 * 60_000
        );
    }
    private _body = {

    };
    public headers: any;
    public options: any;

    getRepInfo(id: string): Observable<IRepPublicData> {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        this.repDID = id;
        localStorage.removeItem('repId');
        localStorage.setItem('repId', id);
        //console.log(localStorage.getItem('repId'));
        const key = `repPublic:${id}`;
        return this.cache.get<IRepPublicData>(
            key,
            () => this._http.get<IRepPublicData>(this._repInfoCall + id, this._body).pipe(
                retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),
                catchError(this.handleError)
            ),
            10 * 60_000
        );
    }
    getProductDetails(sku: string): Observable<IProduct> {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

        const repId = localStorage.getItem('repId') || '';
        const key = `prodDetail:v1:${sku}:${repId}`;
        return this.cache.get<IProduct>(
            key,
            () => this._http.get<IProduct>(this.prodDetailsUrl + sku + '&repDID=' + repId +
                '&langKey=en_US&country=USA').pipe(
                retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),
                catchError(this.handleError)
            ),
            5 * 60_000
        );

    }

    //// need to change this. its using a self defined REST API that utilizes SOAP
    //// and its very slow.
    getProductDetails2(sku: string): Observable<IProductDetail[]> {
        const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
        
        this._body = {
            "ProductId": sku,
            "LocaleId": this.getLangKey()
        };
        const key = `prodDetail:v2:${sku}:${this.getLangKey()}`;
        return this.cache.get<IProductDetail[]>(
            key,
            () => this._http.post<IProductDetail[]>(this.prodDetailsUrl2, this._body).pipe(
                retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),
                catchError(this.handleError)
            ),
            5 * 60_000
        );
    }

    handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side errors
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        //window.alert(errorMessage);
        return throwError(() => new Error(errorMessage));
    }
}
